import React, { useState, useEffect, useRef } from "react";
import pstvue from "../../asstes/pstvue.png";
import { logout } from "../../services/operations/authAPI";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { ChevronDown } from "lucide-react";
import { useTranslation } from "react-i18next";
//import { getSchoolBySchoolID } from "../../services/operations/schoolAPI";

export default function Navbar({ onMenuClick }) {
  const { user } = useSelector((state) => state.profile);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const navigate = useNavigate();
  const dropdownRef = useRef(null);
  const dispatch = useDispatch();
  // const [schoolName, setSchoolName] = useState("");

  // 1. Get the 't' (translate) function from the hook
  // We assume your translations are in the 'common' namespace
  const { i18n, t } = useTranslation("common");

  // Add the language change handler
  const handleLanguageChange = (e) => {
    i18n.changeLanguage(e.target.value);
  };

  const handleLogout = () => {
    dispatch(logout(navigate));
  };

  // useEffect(() => {
  //   const fetchSchool = async () => {
  //    if (!user?.schoolId ) return;

  //     try {
  //       const response = await getSchoolBySchoolID(user.schoolId);
  //       if (response) {
  //         setSchoolName(response.name);
  //       }
  //      // console.log("res",response)
        
  //     } catch (err) {
  //       console.error("FETCH SCHOOL ERROR:", err);
  //     }
  //   };

  //   fetchSchool();
  // }, [user]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    if (dropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownOpen]);

  // Helper variable to get the active plan safely
  const activePlan = user?.subscription?.find((sub) => sub.status === "active")?.plan;

  return (
    <nav className="bg-[#00254D] flex items-center justify-between px-4 sm:px-6 md:px-10 h-20 relative">
      {/* Left side */}
      <div className="flex items-center space-x-4">
        <button
          aria-label={t("navbar.menuAriaLabel")} // Translated
          className="text-white text-xl sm:text-2xl"
          onClick={onMenuClick}
        >
          <i className="fas fa-bars"></i>
        </button>
        <Link to="/dashboard">
          <img src={pstvue} alt={t("navbar.logoAlt")} className="w-18 h-10" />{" "}
          {/* Translated */}
        </Link>
      </div>

      {/* Right side (subscription + user) */}
      <div className="flex items-center space-x-4 sm:space-x-6 text-white text-sm sm:text-base relative">
        {/* School Name
        {schoolName ? (
          <div className="hidden sm:block text-white font-semibold text-sm sm:text-base bg-[#003366] px-3 py-1 rounded-lg shadow">
            {schoolName}
          </div>
        ) : null} */}

        {/* Add the Language Switcher JSX */}
        <div className="relative">
          <select
            value={i18n.resolvedLanguage}
            onChange={handleLanguageChange}
            className="bg-[#00254D] text-white border border-gray-500 rounded-md py-1.5 px-2 text-sm font-medium hover:bg-[#003366] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-[#00254D] focus:ring-white"
          >
            <option value="en" className="text-black">
              {t("navbar.langEnglish")} {/* Translated */}
            </option>
            <option value="te" className="text-black">
              {t("navbar.langTelugu")} {/* Translated */}
            </option>
          </select>
        </div>

        {/* User dropdown */}
        {user && (
          <div className="relative" ref={dropdownRef}>
            <button
              onClick={() => setDropdownOpen(!dropdownOpen)}
              className="flex items-center font-semibold text-sm sm:text-base select-none hover:text-[#a3b4ff] transition-colors"
            >
              {user.name}
              <ChevronDown
                className={`ml-1 w-4 h-4 transition-transform ${
                  dropdownOpen ? "rotate-180" : ""
                }`}
              />
            </button>

            {dropdownOpen && (
              <div className="absolute right-0 mt-3 w-64 bg-white text-[#012950] rounded-lg shadow-lg border border-gray-200 z-50">
                <div className="px-4 py-3 space-y-1">
                  <p className="font-semibold text-sm">
                    {t("navbar.userName")}: {user.name}
                  </p>
                  <p className="text-xs text-[#012950]">
                    {t("navbar.userEmail")}: {user.email}
                  </p>
                  <p className="text-xs text-gray-600">
                    {t("navbar.role")}:{" "}
                    <span className="text-[#00254D] font-medium">
                      {t(`navbar.${user.role}Role`)}
                    </span>
                  </p>

                  {(user.role === "student" || user.role === "teacher") && (
                    <p className="text-xs text-gray-600">
                      {user.role === "student"
                        ? t("navbar.class")
                        : t("navbar.teachesClass")}
                      : <span className="text-[#00254D]">{user.class}</span>
                    </p>
                  )}
                  {user.role === "student" && activePlan && (
                    <p className="text-xs text-gray-600 mt-1">
                      Plan:{" "}
                      <span className="text-green-600 font-bold capitalize">
                        {activePlan}
                      </span>
                    </p>
                  )}
                </div>

                <div className="border-t border-gray-200"></div>

                <button
                  onClick={handleLogout}
                  className="w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50 hover:text-red-700 transition-colors"
                >
                  {t("navbar.logout")}
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </nav>
  );
}
